"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditTable = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const audit_1 = require("../../../model/audit");
const helpers_1 = require("../../../utils/helpers");
const date_picker_1 = require("../../../widgets/date_picker");
const form_for_1 = require("../../../widgets/form_for");
const right_panel_1 = require("../../../widgets/right_panel");
const table_1 = require("../../../widgets/table");
const moment = require("moment");
let startDate;
let endDate;
function getDateValue() {
    if (startDate && endDate) {
        return [startDate, endDate].join(" - ");
    }
    else {
        return undefined;
    }
}
function setDateValue(x) {
    if (!x || x === "") {
        startDate = undefined;
        endDate = undefined;
    }
    else {
        [startDate, endDate] = x.split(/ - /);
    }
}
const renderFilters = () => {
    let filters = {};
    audit_1.AuditEventTypes.forEach(it => {
        filters[it.id] = it.text;
    });
    return filters;
};
function getColorCode(type) {
    let eventType = audit_1.AuditEventTypes.find(v => v.id == type);
    if (eventType) {
        return eventType.color;
    }
    else {
        return "white";
    }
}
exports.AuditTable = (0, table_1.createTable)({
    id: "auditTable",
    provider: audit_1.AuditProvider,
    filters: renderFilters(),
    title: "Historique",
    ajax: (data, provider) => {
        if (startDate) {
            data.starts_at = moment.tz(startDate, "DD/MM/YYYY HH:mm", app_1.App.BOOKING_TIMEZONE).tz("UTC").format();
        }
        if (endDate) {
            data.ends_at = moment.tz(endDate, "DD/MM/YYYY HH:mm", app_1.App.BOOKING_TIMEZONE).tz("UTC").format();
        }
        return provider.index(data);
    },
    topMenuRight: () => {
        return (0, form_for_1.columns)((0, mithril_1.default)(date_picker_1.DateRangePicker, {
            value: getDateValue(),
            onchange: (str) => {
                setDateValue(str);
                exports.AuditTable.fetch();
            }
        }));
    },
    rowRenderer: (mdl, children) => {
        let color = getColorCode(mdl.type);
        return (0, mithril_1.default)("tr", { style: `background-color: ${color}` }, children);
    },
    fields: [
        {
            name: "created_at",
            sortable: false,
            label: "Date",
            renderer: (x) => {
                let date = moment(x.created_at);
                return (0, helpers_1.tag)((0, helpers_1.formatTime)(date, true, true));
            }
        },
        {
            name: "content",
            sortable: false,
            label: "Action",
            renderer: (x) => {
                return (0, mithril_1.default)("div", mithril_1.default.trust(x.content));
            }
        },
        {
            name: "client",
            sortable: false,
            label: "Client",
            renderer: (x) => {
                let c = x.client;
                return (0, mithril_1.default)("div", right_panel_1.RightPanel.linkTo(c.name, "clients", c.id, "show"));
            }
        },
        {
            name: "type",
            sortable: false,
            label: "Type",
            renderer: (x) => {
                return audit_1.AuditTypes[x.type] || x.type;
            }
        },
        {
            name: "actioner",
            sortable: false,
            label: "Effectué par",
            renderer: (x) => {
                let a = x.actioner;
                if (a) {
                    return (0, mithril_1.default)("div", a.name);
                }
                else {
                    return (0, helpers_1.empty)(null, "<systeme>");
                }
            }
        }
    ]
});
